import MainAnnouncement from "../components/announcement-component/main-announcements";

function Announcements() {
  return (
    <div className="w-[95%] mx-auto">
        
      <MainAnnouncement />
    </div>
  );
}

export default Announcements;